module.exports = __webpack_public_path__ + "img/account-welcome-background-white.f64cbfa8.jpg";